import { render, staticRenderFns } from "./examination-paper-modal.vue?vue&type=template&id=3424d2ba&scoped=true"
import script from "./examination-paper-modal.vue?vue&type=script&lang=js"
export * from "./examination-paper-modal.vue?vue&type=script&lang=js"
import style0 from "./examination-paper-modal.vue?vue&type=style&index=0&id=3424d2ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424d2ba",
  null
  
)

export default component.exports